export default {"src":"/_next/static/media/ic_leagues_medals_summary_info.990c3a87.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};